module.exports = __webpack_public_path__ + "img/cowise5.3270d352.png";